import { Environment } from './environment';

export const environment: Environment = {
  mode: 'production',
  apiBaseUrl: 'https://api.solid-app.de',
  kirbyBaseUrl:  'https://solid-app.de',
};
